import React from "react";

const About = ({ data }) => {
  if (data) {
    // var name = data.name;
    // var Logo = "images/" + data.Logo;
    var CeoI = "images/" + data.CeoImage;
    // var CompanyBio = data.CompanyBio;
    // var Ceo = data.CeoBio;
    // var street = data.address.street;
    // var city = data.address.city;
    // var state = data.address.state;
    // var zip = data.address.zip;
    // var phone = data.phone;
    var email = data.email;
  }

  return (
    <section id="about">
      {/* <div className="row">
        <div className="three columns">
          <img className="profile-pic1" src={Logo} alt="CEO's Profile Pic" />
        </div>
        <div className="nine columns main-col">
          <h2>About Us</h2>

          <p>{CompanyBio}</p>
        </div>
      </div>
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; */}
      <div className="row">
        <div className="three columns">
          <img className="profile-pic2" src={CeoI} alt="CastiFy" />
        </div>
        <div className="nine columns main-col">
          <h2>Meet Our CEO</h2>
          <p>Shivam Gupta, the visionary behind Castify, began his journey in Bareilly, where his love for storytelling was first kindled. In Delhi, he gained invaluable experience in stage shows, but it was in Mumbai that his career truly took off. Starting with no connections, Shivam's determination led him to a pivotal role as an assistant director in TV. After a year, he transitioned to casting, starting as an intern under the esteemed Aditya Suorana. His dedication quickly saw him rise to the role of casting assistant, collaborating with numerous casting directors and production houses. 
          <br/>
          <br/>  
          Today, Shivam boasts an impressive portfolio, having worked on 7-8 web shows, multiple films, and numerous TV shows. His expertise extends to over 500 TV commercials, making him a trusted name in the industry. His recent success with the web show Ranneeti: Balakot & Beyond has earned widespread acclaim, cementing his reputation as a leading figure in casting. Shivam is passionate about bringing characters to life, ensuring each one has a unique essence and unparalleled quality</p>
          <div className="row">
            <div className="columns contact-details">
              <h2>Contact Details</h2>
              <p className="address">
                <span>{email}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
